import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import DetailItem from "../table/DetailItem";
import ButtonDropdown from "../../../../components/ButtonDropdown";
import BpjsHistoryDeduction from "../../../../services/BpjsHistoryDeduction";
import Edit from "./Edit";
import "react-toastify/dist/ReactToastify.css";

const Detail = (props) => {
  const { data, activeModal, submitBpjsHandler, closeModal, masterBpjs } = props;
  const dataMaster = data?.information || {};
  const activeClass = activeModal ? "effect-scale show" : "";
  const activeStyle = activeModal ? { display: "block", paddingRight: "17px" } : {};

  const [list, setList] = useState([]);
  const [year, setYear] = useState(moment().format("YYYY"));
  const [editData, setEditData] = useState(null);
  const [editModal, setEditModal] = useState(false);

  const curYear = moment().add(1, "M").format("YYYY");

  const yearHandler = (yearOption) => {
    setYear(yearOption);
  };

  useEffect(() => {
    if (activeModal) {
      BpjsHistoryDeduction.history(dataMaster.id, year)
        .then((res) => {
          setList(res?.data?.data || []);
        })
        .catch((err) => {
          console.error("BPJS History Error:", err);
        });
    }
  }, [activeModal, year, dataMaster.id]);

  const dropdownObj = [];
  for (let i = curYear; i >= 2021; i--) {
    const yearOption = i;
    dropdownObj.push({
      name: yearOption,
      clickFunction: () => yearHandler(yearOption),
    });
  }

  const action = <ButtonDropdown button="btn-dark btn-sm px-4" title={year} dropdown={dropdownObj} />;

  const submitHandler = (e) => {
    e.preventDefault();
    submitBpjsHandler([...list]);
  };

  const editHandler = (item) => {
    setEditData({
      activeModal: true,
      data: item,
      dataDetail: data,
      masterBpjs: masterBpjs,
    });
    setEditModal(true);
  };

  const deleteHandler = (item) => {
    if (!item || !item.id) return;

    if (!item.can_delete && editData?.data?.id === item.id) {
      setEditData(null);
      setEditModal(false);

      setList((prevList) => prevList.filter((row) => row.id !== item.id));
      return;
    }

    if (item.can_delete === true) {
      const payload = {
        items: [
          {
            payment_status: "default",
            payment_date: null,
            month: item.month || null,
            year: item.year || null,
            note: item.note || null,
          },
        ],
      };

      if (typeof props.deleteHandler === "function") {
        props.deleteHandler(payload.items);
      } else {
        console.warn("deleteHandler prop is not a function");
      }
    }
  };

  const confirmHandler = (updatedItem) => {
    setList((prev) => prev.map((row) => (row.id === updatedItem.id ? { ...row, ...updatedItem } : row)));
    setEditModal(false);
  };

  const closeEditModal = () => setEditModal(false);

  return (
    <>
      <div className={`modal fade ${activeClass}`} id="modalDetailBPJS" style={activeStyle} role="dialog" aria-modal="true">
        <div className="modal-dialog modal-dialog-scrollable modal-xl text-center modal-dialog-centered" role="document">
          <div className="modal-content modal-content-demo shadow-lg">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {`List Pembayaran BPJS | ${dataMaster.worker_name || "N/A"}`} - {dataMaster.id || "N/A"}
              </h5>
              <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" onClick={closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="flex flex-row justify-content-between align-items-center w-full">
                <div className="text-end mb-2">
                  <h6 className="fw-bold">Tahun {year}</h6>
                </div>
                <div className="text-end mb-2">{action}</div>
              </div>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>BPJS</th>
                    {/* <th>Remaining Deposit</th> */}
                    <th>Note</th>
                    <th>#</th>
                  </tr>
                </thead>

                <tbody>
                  {list.length > 0 ? (
                    list.map((item) => (
                      <DetailItem
                        key={item.id}
                        data={item}
                        dataDetail={props}
                        editHandler={() => editHandler(item)}
                        deleteHandler={() => deleteHandler(item)}
                        closeModal={closeModal}
                      />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center text-muted">
                        Tidak ada data BPJS untuk tahun {year}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="modal-footer">
              <form className="form-horizontal" onSubmit={submitHandler}>
                <button className="btn text-danger me-5" data-bs-dismiss="modal" onClick={closeModal}>
                  Batalkan
                </button>
                <button className="btn btn-primary px-7">Simpan</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {editModal && (
        <Edit
          activeModal={editData.activeModal}
          data={editData.data}
          dataDetail={editData.dataDetail}
          masterBpjs={masterBpjs}
          year={year}
          closeModal={closeEditModal}
          confirmHandler={confirmHandler}
        />
      )}
    </>
  );
};

export default Detail;
